var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loading',[_c('div',{staticClass:"p-4"},[_c('Row',{staticClass:"input-row",attrs:{"rounded":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }